/**
 * First `path` in filtered sidebar menu groups (depth-first: Items order, then each sub's children).
 * Matches how `useMenuItems` builds Makkah/Madina menus.
 *
 * @param {{ menutitle?: string, Items?: unknown[] }[] | null | undefined} menuGroups
 * @returns {string | null}
 */
export function getFirstMenuLinkPath(menuGroups) {
  if (!Array.isArray(menuGroups)) return null;
  for (const group of menuGroups) {
    const path = walkMenuItems(group?.Items);
    if (path) return path;
  }
  return null;
}

/** @param {unknown[] | null | undefined} items */
function walkMenuItems(items) {
  if (!Array.isArray(items)) return null;
  for (const item of items) {
    if (!item || typeof item !== "object") continue;
    if (item.type === "link" && typeof item.path === "string") return item.path;
    if (item.type === "sub" && Array.isArray(item.children)) {
      const nested = walkMenuItems(item.children);
      if (nested) return nested;
    }
  }
  return null;
}
